import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, OnDestroy, inject, signal } from '@angular/core'

@Directive({
  selector: '[appTruncationDetector]',
  exportAs: 'appTruncationDetector',
  standalone: true
})
export class TruncationDetectorDirective implements AfterViewInit, OnDestroy {
  public readonly isTruncated = signal(false)

  private readonly _host = inject<ElementRef<HTMLElement>>(ElementRef)
  private readonly _changeDetectorRef = inject(ChangeDetectorRef)
  private _resizeObserver: ResizeObserver | null = null

  ngAfterViewInit(): void {
    const element = this._host.nativeElement
    if (typeof ResizeObserver !== 'undefined') {
      this._resizeObserver = new ResizeObserver(() => this._update())
      this._resizeObserver.observe(element)
    }
    queueMicrotask(() => this._update())
  }

  ngOnDestroy(): void {
    this._resizeObserver?.disconnect()
  }

  /**
   * Updates the truncation state based on the host element's overflow.
   */
  private _update(): void {
    const element = this._host.nativeElement
    const truncated = element.scrollHeight > element.clientHeight + 1 || element.scrollWidth > element.clientWidth + 1

    if (truncated === this.isTruncated()) return

    this.isTruncated.set(truncated)
    this._changeDetectorRef.markForCheck()
  }
}
